module.exports = __webpack_public_path__ + "static/media/aboutimg3.fcbf5a5f.webp";